module.exports = __webpack_public_path__ + "img/yun.0e2ce2cc.png";